/* ELC Shift — Screens module (KPI screen + data aggregation, Area-overview screen).
   Extracted from index.html block #22 (Sprint 3) via AST. Behaviour-preserving: each function
   was a global inline declaration, so all are re-exposed on window. Reads app globals
   (DB, currentStore, staffData, window.renderKpiScreen/renderRotaWeek…) at runtime. */
(function(){

function changeAreaViewWeek(dir){
  if(!areaViewWeekStart)areaViewWeekStart=getWeekStart(new Date());
  areaViewWeekStart=new Date(areaViewWeekStart);
  areaViewWeekStart.setDate(areaViewWeekStart.getDate()+dir*7);
  renderAreaScreen();
}

function switchAreaTab(tab){
  currentAreaTab=tab;
  ['rota','clock','balances'].forEach(function(t){
    document.getElementById('areaTab'+t.charAt(0).toUpperCase()+t.slice(1)).classList.toggle('active',t===tab);
    document.getElementById('area'+t.charAt(0).toUpperCase()+t.slice(1)+'View').style.display=t===tab?'block':'none';
  });
  renderAreaTabContent(tab);
}

function renderAreaScreen(){
  if(!areaViewWeekStart)areaViewWeekStart=getWeekStart(new Date());
  var wkEnd=new Date(areaViewWeekStart);wkEnd.setDate(wkEnd.getDate()+6);
  document.getElementById('areaViewWeekLabel').textContent=
    areaViewWeekStart.toLocaleDateString('en-GB',{day:'numeric',month:'short'})+' – '+
    wkEnd.toLocaleDateString('en-GB',{day:'numeric',month:'short'});
  renderAreaTabContent(currentAreaTab);
}

function renderAreaTabContent(tab){
  var myStores=getMyStores();
  if(tab==='rota')renderAreaRotaTab(myStores);
  if(tab==='clock')renderAreaClockTab(myStores);
  if(tab==='balances')renderAreaBalancesTab(myStores);
}

function renderAreaRotaTab(myStores){
  var displayDays=['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  var wkStr=localDateStr(areaViewWeekStart);
  var html='';
  myStores.forEach(function(store){
    var staff=getStoreStaff(store);
    if(!staff.length)return;
    var displayNames=computeDisplayNames(staff);
    var isQ=getStoreCountry(store)==='ELC - Qatar';
    var days=isQ?['Sun','Mon','Tue','Wed','Thu','Fri','Sat']:displayDays;
    html+='<div style="margin-bottom:16px">';
    html+='<div style="font-size:12px;font-weight:700;color:var(--text);padding:8px 10px;background:var(--surface-2);border-radius:8px 8px 0 0;border:1px solid var(--border);border-bottom:none;display:flex;align-items:center;gap:6px">';
    html+=(isQ?'🇶🇦':'🇦🇪')+' '+store;
    html+='<span style="font-size:10px;color:var(--sub);font-weight:400;margin-inline-start:auto">'+staff.length+' staff</span></div>';
    html+='<div style="overflow-x:auto;border:1px solid var(--border);border-radius:0 0 8px 8px"><table style="width:100%;border-collapse:collapse;font-size:11px">';
    html+='<thead><tr><th style="padding:5px 8px;text-align:start;background:var(--surface-2);border-bottom:1px solid var(--border);white-space:nowrap">Staff</th>';
    days.forEach(function(d){html+='<th style="padding:5px 6px;text-align:center;background:var(--surface-2);border-bottom:1px solid var(--border)">'+d+'</th>';});
    html+='</tr></thead><tbody>';
    staff.forEach(function(s){
      html+='<tr>';
      html+='<td style="padding:4px 8px;font-weight:600;white-space:nowrap;border-bottom:1px solid var(--border)" translate="no">'+escapeHtml(displayNames[s.id]||s.name.split(' ')[0])+'</td>';
      days.forEach(function(day){
        var sh=getShift(s.id,day,areaViewWeekStart);
        var cell='';
        if(!sh)cell='<span style="color:var(--border-strong);font-size:10px">—</span>';
        else if(sh.type==='off')cell='<span style="background:var(--danger-bg);color:var(--danger-deep);padding:1px 5px;border-radius:4px;font-size:10px">D/O</span>';
        else if(sh.type==='work')cell='<span style="background:var(--ok-bg);color:var(--ok-deep);padding:1px 5px;border-radius:4px;font-size:10px">'+sh.start+'</span>';
        else if(sh.type==='holiday')cell='<span style="background:var(--warn-bg);color:var(--warn-deep);padding:1px 5px;border-radius:4px;font-size:10px">🌴</span>';
        else if(sh.type==='sick')cell='<span style="background:var(--rota-danger-soft);color:var(--rota-rose-deep);padding:1px 5px;border-radius:4px;font-size:10px">🤒</span>';
        else if(sh.type==='toil')cell='<span style="background:var(--rota-purple-soft);color:var(--rota-purple-deep);padding:1px 5px;border-radius:4px;font-size:10px">TOIL</span>';
        // v129.18: without this an APL day rendered as an EMPTY cell in the AM's
        // cross-store grid — reading as missing data rather than as leave.
        else if(sh.type==='apl')cell='<span style="background:var(--rota-teal-bg);color:var(--rota-teal-deep);padding:1px 5px;border-radius:4px;font-size:10px">APL</span>';
        html+='<td style="padding:4px 3px;text-align:center;border-bottom:1px solid var(--border)">'+cell+'</td>';
      });
      html+='</tr>';
    });
    html+='</tbody></table></div></div>';
  });
  if(!html)html='<div style="text-align:center;padding:40px;color:var(--sub)">No stores found</div>';
  document.getElementById('areaRotaView').innerHTML=html;
}

function renderAreaClockTab(myStores){
  var today=todayStr();
  var html='';
  myStores.forEach(function(store){
    var staff=getStoreStaff(store);
    if(!staff.length)return;
    // v80.16: disambiguate first names within this store's roster
    var nameMap = buildFirstNameMap(staff);
    html+='<div style="margin-bottom:14px"><div style="font-size:12px;font-weight:700;padding:8px 10px;background:var(--surface-2);border-radius:8px 8px 0 0;border:1px solid var(--border);border-bottom:none">'+(getStoreCountry(store)==='ELC - Qatar'?'🇶🇦':'🇦🇪')+' '+store+'</div>';
    html+='<div style="border:1px solid var(--border);border-radius:0 0 8px 8px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:11px">';
    html+='<thead><tr><th style="padding:5px 8px;text-align:start;background:var(--surface-2)">Name</th><th style="padding:5px 8px;background:var(--surface-2)">In</th><th style="padding:5px 8px;background:var(--surface-2)">Out</th><th style="padding:5px 8px;background:var(--surface-2)">Status</th></tr></thead><tbody>';
    staff.forEach(function(s){
      var sh=getShift(s.id,getDayKey(new Date()),areaViewWeekStart||currentWeekStart);
      var ev=Clock.events[s.id]||{};
      var status='',statusColor='var(--sub)';
      if(sh&&sh.type==='off'){status='D/O';statusColor='var(--tiny)';}
      else if(ev.clockIn&&!ev.clockOut){status='On floor';statusColor='var(--rota-green-ink)';}
      else if(ev.clockIn&&ev.clockOut){status='Clocked out';statusColor='var(--sub)';}
      else if(sh&&sh.type==='work'){status='Expected';statusColor='#f59e0b';}
      else{status='—';statusColor='var(--border-strong)';}
      html+='<tr style="border-top:1px solid var(--border)"><td style="padding:4px 8px;font-weight:600" translate="no">'+(nameMap[s.id]||s.name.split(' ')[0])+'</td>';
      html+='<td style="padding:4px 8px;color:var(--rota-green-ink)">'+(ev.clockIn||'—')+'</td>';
      html+='<td style="padding:4px 8px;color:var(--sub)">'+(ev.clockOut||'—')+'</td>';
      html+='<td style="padding:4px 8px"><span style="color:'+statusColor+';font-weight:600;font-size:10px">'+status+'</span></td></tr>';
    });
    html+='</tbody></table></div></div>';
  });
  if(!html)html='<div style="text-align:center;padding:40px;color:var(--sub)">No stores</div>';
  document.getElementById('areaClockView').innerHTML=html;
}

function onKpiStoreChange(){
  var sel = document.getElementById('kpiStoreSelect');
  if (!sel) return;
  _kpiCurrentStore = sel.value;
  loadKpiData(_kpiCurrentStore);
}

// v130.48 — HOW MUCH of the year to ask for.
//
// The screen used to request the whole calendar year, every time:
//   from = YYYY-01-01, to = YYYY-12-31
// which is 147 KB for one store, of which ~50 KB is future dates that
// src/kpi/index.js then DISCARDS client-side (the _kpiShowFuture filter).
// Downloading and parsing a third of a payload in order to throw it away is
// not free on a store till over mall wifi - this screen was taking about a
// minute to open (Matt, 26 Aug).
//
// WHY THE END OF THE MONTH, and not today: the cards read today and past
// days, but the demo-line card reads THIS WEEK and the month-target maths
// needs every day of the current month - including the ones still to come.
// Clipping at today would quietly understate a performance-visible number,
// which is a worse bug than the one being fixed. End-of-month keeps every
// current calculation whole and still drops the rest of the year.
//
// When the user asks for the full year ("Show full year"), we fetch it.
// NOT exported: this file is a plain script (esbuild bundles it as an IIFE with
// globalName Screens). Adding an export would make it a module and hand window.Screens
// the exports object - the v125.14 clobber class. window-bind instead, like its siblings.
function kpiFetchRange(now, showFuture) {
  var d = now || new Date();
  var year = d.getFullYear();
  var pad = function (n) { return String(n).padStart(2, "0"); };
  if (showFuture) return { from: year + "-01-01", to: year + "-12-31" };
  // Day 0 of next month = the last day of this one (handles 28/29/30/31).
  var end = new Date(year, d.getMonth() + 1, 0);
  return {
    from: year + "-01-01",
    to: end.getFullYear() + "-" + pad(end.getMonth() + 1) + "-" + pad(end.getDate()),
  };
}

async function loadKpiData(store){
  var content = document.getElementById('kpiContent');
  var subEl = document.getElementById('kpiHeaderSub');
  if (subEl) subEl.textContent = store;
  content.innerHTML = '<div style="font-size:13px;color:var(--sub);text-align:center;padding:40px 14px">Loading…</div>';
  // Reset cards while loading
  ['kpiTodayValue','kpiVsTargetValue','kpiVsLyValue'].forEach(function(id){
    var el = document.getElementById(id); if (el) el.textContent = '—';
  });
  ['kpiTodaySub','kpiVsTargetSub','kpiVsLySub'].forEach(function(id){
    var el = document.getElementById(id); if (el) el.innerHTML = '&nbsp;';
  });
  var aggBody = document.getElementById('kpiAggregateBody');
  if (aggBody) aggBody.innerHTML = '<div style="font-size:12px;color:var(--sub);text-align:center;padding:14px">Loading…</div>';

  try {
    var year = new Date().getFullYear();
    // v130.48 — ask for what this screen actually renders, not the whole year.
    var range = kpiFetchRange(new Date(), typeof _kpiShowFuture !== "undefined" && _kpiShowFuture);
    // v130.52 - start the INDEPENDENT reads NOW, not after the list resolves.
    // Measured on prod: a Supabase round trip costs ~500 ms almost regardless of
    // how much it returns (one DAY of KPI rows: 644 ms; one YEAR: 573 ms). So
    // sequencing two independent reads added a whole round trip to every open
    // of this screen for nothing. loadAggregateKpi renders into its own element
    // and reads neither _kpiData nor _kpiNotes, so it can run alongside.
    var pAgg = loadAggregateKpi(store);
    if (pAgg && pAgg.catch) pAgg.catch(function (e) { console.warn("[kpi] aggregate failed:", e && e.message); });
    // Remember how far the cached rows reach, so the "Show full year" toggle
    // knows whether it must re-fetch or can just re-render.
    window._kpiLoadedThrough = range.to;
    var rows = await DB.kpi.list({ store: store, from: range.from, to: range.to });
    _kpiData = Array.isArray(rows) ? rows : [];

    // v79.6: load daily notes in parallel — keyed by date for fast lookup.
    DB.daily_notes.list({ store: store, from: range.from, to: range.to })
      .then(function(notes){
        _kpiNotes = {};
        (notes || []).forEach(function(n){ _kpiNotes[n.date] = n; });
        // Re-render the active tab so notes appear inline
        renderKpiTab(_kpiActiveTab);
      })
      .catch(function(e){ console.warn('[kpi] notes load failed:', e && e.message); });

    renderKpiCards(_kpiData);
    renderKpiTab(_kpiActiveTab);
    renderDemoLineCard(_kpiData);
    renderKpiAiSummaryCard();   // v79.11 — initial state of AI summary card
    // v130.52 - the bonus tracker already started above, in parallel with the
    // list read. Nothing to call here.
  } catch(e) {
    console.warn('[kpi] load failed:', e && e.message);
    content.innerHTML = '<div style="font-size:13px;color:var(--danger);text-align:center;padding:40px 14px">Couldn\'t load KPI data: ' + escapeHtml(e && e.message || 'unknown') + '</div>';
  }
}

async function loadAggregateKpi(store){
  var body = document.getElementById('kpiAggregateBody');
  if (!body) return;
  // Populate the month dropdown once (last 12 months) so a store can review a PAST
  // month's store / country / company totals, not just month/quarter/year-to-date.
  var msel = document.getElementById('kpiAggregateMonthSelect');
  if (msel && msel.options.length <= 1) {
    buildMonthOptions().slice(0, 12).forEach(function(o){
      var opt = document.createElement('option');
      opt.value = o.value; opt.textContent = o.label;
      msel.appendChild(opt);
    });
  }
  var range = aggregateScopeToRange(_kpiAggregateScope);
  body.innerHTML = '<div style="font-size:12px;color:var(--sub);text-align:center;padding:14px">Loading…</div>';
  try {
    var data = await DB.kpi.aggregate({ store: store, from: range.from, to: range.to });
    renderAggregateKpi(data);
  } catch(e) {
    console.warn('[kpi-agg] load failed:', e && e.message);
    body.innerHTML = '<div style="font-size:11px;color:var(--danger);text-align:center;padding:14px">Couldn\'t load aggregate: ' + escapeHtml(e && e.message || 'unknown') + '</div>';
  }
}

function aggregateScopeToRange(scope){
  var now = new Date();
  var y = now.getFullYear(), m = now.getMonth();
  // v86.13: yesterday-cap is now a shared helper. See dates.js
  // effectiveToday() for full rationale (was v81.2's inline logic).
  var yesterdayStr = effectiveToday();
  if (scope === 'QTD') {
    var qStart = Math.floor(m / 3) * 3;
    return { from: y + '-' + String(qStart + 1).padStart(2, '0') + '-01', to: yesterdayStr };
  }
  if (scope === 'YTD') {
    return { from: y + '-01-01', to: yesterdayStr };
  }
  // A specific past month token 'YYYY-MM' (from the month dropdown) — lets a store
  // review a past month's store/country/company totals. Full calendar month, except
  // the CURRENT month which is capped at yesterday (same as MTD). Mirrors
  // compareScopeRange()'s month branch so the two stay consistent.
  if (/^\d{4}-\d{2}$/.test(scope)) {
    var parts = scope.split('-');
    var sy = Number(parts[0]), sm = Number(parts[1]) - 1;
    var smLast = new Date(sy, sm + 1, 0).getDate();
    var sTo = (sy === y && sm === m) ? yesterdayStr : (scope + '-' + String(smLast).padStart(2, '0'));
    return { from: scope + '-01', to: sTo };
  }
  // Default MTD
  return { from: y + '-' + String(m + 1).padStart(2, '0') + '-01', to: yesterdayStr };
}

async function generateKpiAiSummary() {
  if (_kpiAiSummaryLoading) return;
  if (!currentStore) {
    showToast('No store selected', 'error');
    return;
  }
  var scope = document.getElementById('kpiAiSummaryScope').value || 'MTD';
  _kpiAiSummaryLoading = true;
  renderKpiAiSummaryCard();
  try {
    var resp = await DB.kpi.summary({ store: currentStore, scope: scope });
    if (!resp || !resp.summary) {
      throw new Error('Empty response from AI');
    }
    _kpiAiSummary = {
      text:         resp.summary.trim(),
      generated_at: resp.generated_at,
      scope:        resp.scope,
      from:         resp.from,
      to:           resp.to,
    };
  } catch (e) {
    // 429 rate-limited → friendly message. Otherwise generic.
    var msg = e && e.message ? e.message : String(e);
    showToast('AI summary failed: ' + msg, 'error');
    _kpiAiSummary = null;
  } finally {
    _kpiAiSummaryLoading = false;
    renderKpiAiSummaryCard();
  }
}

function cancelDemoLineEdit(){
  document.getElementById('demoLineEditor').style.display = 'none';
}

async function saveDemoLine(){
  var nameEl  = document.getElementById('demoLineItemInput');
  var priceEl = document.getElementById('demoLinePriceInput');
  var statusEl = document.getElementById('demoLineEditStatus');
  var btn = document.getElementById('demoLineSaveBtn');
  var name  = (nameEl.value || '').trim();
  var price = parseFloat(priceEl.value);
  if (!name || isNaN(price) || price <= 0) {
    statusEl.textContent = 'Please enter both an item name and a positive price.';
    statusEl.style.color = 'var(--danger-deep)';
    return;
  }
  if (!_kpiCurrentStore) {
    statusEl.textContent = 'No store selected.';
    statusEl.style.color = 'var(--danger-deep)';
    return;
  }
  var todayStr = localDateStr(new Date());
  var todayWeek = isoWeekFromDateStr(todayStr);
  btn.disabled = true;
  statusEl.textContent = 'Saving Week ' + todayWeek.week + '…';
  statusEl.style.color = 'var(--sub)';
  try {
    await DB.demo_line.set({
      store:        _kpiCurrentStore,
      iso_year:     todayWeek.year,
      iso_week:     todayWeek.week,
      item_name:    name,
      retail_price: price,
      set_by:       (currentUser && currentUser.name) || 'staff',
    });
    statusEl.textContent = 'Saved.';
    statusEl.style.color = 'var(--ok)';
    document.getElementById('demoLineEditor').style.display = 'none';
    loadKpiData(_kpiCurrentStore);
  } catch(e) {
    console.warn('[demo-line] save failed:', e && e.message);
    statusEl.textContent = 'Save failed: ' + (e && e.message || 'unknown');
    statusEl.style.color = 'var(--danger-deep)';
  } finally {
    btn.disabled = false;
  }
}

function cancelKpiNote() {
  _kpiNoteEditingDate = null;
  renderKpiTab(_kpiActiveTab);
}

async function saveKpiNote(dateStr) {
  var ta = document.getElementById('kpiNoteInput_' + dateStr);
  if (!ta) return;
  var noteText = (ta.value || '').trim();
  if (!_kpiCurrentStore) {
    showToast('No store selected', 'error');
    return;
  }
  // Empty save = treat as delete
  if (!noteText) {
    return deleteKpiNote(dateStr);
  }
  ta.disabled = true;
  try {
    var saved = await DB.daily_notes.save({
      store: _kpiCurrentStore,
      date:  dateStr,
      note:  noteText,
      set_by: (currentUser && currentUser.name) || 'staff',
    });
    // Update local cache so the UI reflects without a full reload
    _kpiNotes[dateStr] = (saved && saved.id) ? saved : { date: dateStr, note: noteText };
    _kpiNoteEditingDate = null;
    showToast('Note saved', 'success');
    renderKpiTab(_kpiActiveTab);
  } catch(e) {
    console.warn('[kpi-note] save failed:', e && e.message);
    showToast('Save failed: ' + (e && e.message || 'unknown'), 'error');
    ta.disabled = false;
  }
}

async function deleteKpiNote(dateStr) {
  if (!_kpiCurrentStore) return;
  if (!(await (window.uiConfirm || function (m) { return Promise.resolve(confirm(m)); })('Delete the note for this day?', { danger: true, confirmLabel: 'Delete' }))) return;
  try {
    // POST with empty note triggers a server-side delete (see worker /api/daily_notes POST)
    await DB.daily_notes.save({
      store: _kpiCurrentStore,
      date:  dateStr,
      note:  '',
      set_by: (currentUser && currentUser.name) || 'staff',
    });
    delete _kpiNotes[dateStr];
    _kpiNoteEditingDate = null;
    showToast('Note deleted', 'success');
    renderKpiTab(_kpiActiveTab);
  } catch(e) {
    console.warn('[kpi-note] delete failed:', e && e.message);
    showToast('Delete failed: ' + (e && e.message || 'unknown'), 'error');
  }
}

function isoWeekFromDateStr(dateStr){
  // Parse YYYY-MM-DD as a local-noon UTC date (avoids DST drift), then
  // apply ISO 8601 week calculation: Thursday of the week determines
  // the week's year, then count Thursdays from the year's first Thursday.
  var parts = dateStr.split('-');
  var d = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])));
  // Move to Thursday of this ISO week (day 4)
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // First day of the year, in UTC
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Week number = ceil( (days since year start + 1) / 7 )
  var weekNum = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return { year: d.getUTCFullYear(), week: weekNum };
}

function monthLabelFromDateStr(dateStr){
  var parts = dateStr.split('-');
  var month = Number(parts[1]) - 1;
  var year = Number(parts[0]);
  var MON = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  return { sortKey: parts[0] + '-' + parts[1], label: MON[month], year: year };
}

function aggregateRows(rows, keyFn){
  var byPeriod = {};
  rows.forEach(function(r){
    if (!r.date) return;
    var k = keyFn(r.date);
    if (!byPeriod[k.sortKey]) {
      byPeriod[k.sortKey] = {
        sortKey: k.sortKey,
        label: k.label,
        year: k.year,
        sales: 0, target: 0, last_year: 0,
        // Track which of the three are present at all in this period
        hasSales: false, hasTarget: false, hasLastYear: false,
        // Period-matched sums for fair % comparisons:
        // only count days where BOTH sides of the comparison have values.
        salesForTargetCmp: 0, targetForCmp: 0,
        salesForLyCmp: 0, lyForCmp: 0,
        // v79.10: addon KPI period totals — sum actuals + targets across days.
        // Null contributions are skipped (treated as no data for that day).
        demoActual:  0, demoTarget:  0,
        batActual:   0, batTarget:   0,
        wrapActual:  0, wrapTarget:  0,
        bagActual:   0, bagTarget:   0,
        cardsActual: 0, cardsTarget: 0,
      };
    }
    var p = byPeriod[k.sortKey];
    if (r.sales != null)     { p.sales     += Number(r.sales);     p.hasSales = true; }
    if (r.target != null)    { p.target    += Number(r.target);    p.hasTarget = true; }
    if (r.last_year != null) { p.last_year += Number(r.last_year); p.hasLastYear = true; }
    if (r.sales != null && r.target != null) {
      p.salesForTargetCmp += Number(r.sales);
      p.targetForCmp      += Number(r.target);
    }
    if (r.sales != null && r.last_year != null) {
      p.salesForLyCmp += Number(r.sales);
      p.lyForCmp      += Number(r.last_year);
    }
    // Addon KPIs — sum what's present, ignore nulls.
    if (r.actual_demo_units    != null) p.demoActual  += Number(r.actual_demo_units);
    if (r.target_demo_units    != null) p.demoTarget  += Number(r.target_demo_units);
    if (r.actual_batteries     != null) p.batActual   += Number(r.actual_batteries);
    if (r.target_batteries     != null) p.batTarget   += Number(r.target_batteries);
    if (r.actual_gift_wrap     != null) p.wrapActual  += Number(r.actual_gift_wrap);
    if (r.target_gift_wrap     != null) p.wrapTarget  += Number(r.target_gift_wrap);
    if (r.actual_reusable_bag  != null) p.bagActual   += Number(r.actual_reusable_bag);
    if (r.target_reusable_bag  != null) p.bagTarget   += Number(r.target_reusable_bag);
    if (r.actual_gift_cards    != null) p.cardsActual += Number(r.actual_gift_cards);
    if (r.target_gift_cards    != null) p.cardsTarget += Number(r.target_gift_cards);
  });
  return Object.values(byPeriod).sort(function(a,b){ return a.sortKey.localeCompare(b.sortKey); });
}

function isoWeekMonday(isoYear, isoWeek) {
  var jan4 = new Date(Date.UTC(isoYear, 0, 4));
  var jan4Dow = ((jan4.getUTCDay() + 6) % 7) + 1;  // 1=Mon..7=Sun
  var week1Mon = new Date(jan4);
  week1Mon.setUTCDate(jan4.getUTCDate() - jan4Dow + 1);
  var monday = new Date(week1Mon);
  monday.setUTCDate(week1Mon.getUTCDate() + (isoWeek - 1) * 7);
  return monday;
}

function compareScopeRange(scope){
  // Resolves a scope token to {from, to, label}.
  // v86.13: upper bound for "to-date" scopes is YESTERDAY (last
  // completed day), not today — sales lag by one day. See dates.js
  // effectiveToday() for rationale. Specific months use the full
  // calendar range, except the current month which is capped at the
  // same yesterday bound.
  var now = new Date();
  var y = now.getFullYear(), m = now.getMonth();
  var effToday = effectiveToday();

  if (scope === 'YTD') {
    return { from: y + '-01-01', to: effToday, label: 'YTD' };
  }
  if (scope === 'last_month') {
    // Previous calendar month, full range — not affected (both bounds in past)
    var prev = new Date(y, m - 1, 1);
    var prevY = prev.getFullYear(), prevM = prev.getMonth();
    var lastDay = new Date(prevY, prevM + 1, 0).getDate();
    var fromStr = prevY + '-' + String(prevM + 1).padStart(2, '0') + '-01';
    var toStr   = prevY + '-' + String(prevM + 1).padStart(2, '0') + '-' + String(lastDay).padStart(2, '0');
    return { from: fromStr, to: toStr, label: monthLabel(prevY, prevM) };
  }
  // Specific month token: 'YYYY-MM'
  if (/^\d{4}-\d{2}$/.test(scope)) {
    var parts = scope.split('-');
    var sy = Number(parts[0]), sm = Number(parts[1]) - 1;
    var smLast = new Date(sy, sm + 1, 0).getDate();
    var sFrom = scope + '-01';
    var sTo   = scope + '-' + String(smLast).padStart(2, '0');
    // Current month: cap at yesterday (same as MTD default).
    if (sy === y && sm === m) sTo = effToday;
    return { from: sFrom, to: sTo, label: monthLabel(sy, sm) };
  }
  // MTD (default) — current month, partial
  return { from: y + '-' + String(m + 1).padStart(2, '0') + '-01', to: effToday, label: 'MTD' };
}

function monthLabel(year, monthZero){
  var names = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return names[monthZero] + ' ' + year;
}

function buildMonthOptions(){
  // Build a list of {value, label} for the month dropdown. Goes back
  // 24 months from the current month so users can compare against
  // last year or earlier in the year.
  var now = new Date();
  var y = now.getFullYear(), m = now.getMonth();
  var opts = [];
  for (var i = 0; i < 24; i++) {
    var d = new Date(y, m - i, 1);
    var dy = d.getFullYear(), dm = d.getMonth();
    var token = dy + '-' + String(dm + 1).padStart(2, '0');
    opts.push({ value: token, label: monthLabel(dy, dm) });
  }
  return opts;
}

function setCompareScope(scope){
  // Empty string from the dropdown's placeholder option = no-op
  if (!scope) return;
  if (scope === _kpiCompareScope) return;
  _kpiCompareScope = scope;
  renderKpiCompareView();
}

function setCompareSort(key){
  // Click same header again = toggle direction. Click new header = default desc.
  if (_kpiCompareSortBy === key) {
    _kpiCompareSortDir = (_kpiCompareSortDir === 'desc') ? 'asc' : 'desc';
  } else {
    _kpiCompareSortBy = key;
    _kpiCompareSortDir = (key === 'store') ? 'asc' : 'desc';
  }
  renderKpiCompareView();
}

// This store's own customer-satisfaction score — a staff motivator. Reads the
// public /api/customer-score (aggregate only; own store; 1-hour delayed). Hidden
// until there's data. Fetched once per store (cached) so re-renders don't spam.
var _storeScoreFetchedFor = null;
function renderStoreScore(){
  var el = document.getElementById('storeScoreBar'); if(!el) return;
  if(!currentStore){ el.style.display='none'; return; }
  if(_storeScoreFetchedFor === currentStore) return;   // already shown for this store
  _storeScoreFetchedFor = currentStore;
  // v124.2: always-visible card. Show it immediately (loading), then the score OR a
  // friendly "no reviews yet" state — never hide, so staff know their store score
  // lives here even before the first customer review lands.
  el.style.display='flex';
  el.innerHTML = '<span style="color:var(--tiny);font-weight:600">⭐ Loading your store score…</span>';
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  fetch(base + '/api/customer-score?store=' + encodeURIComponent(currentStore), { cache: 'no-store' })
    .then(function(r){ return r.json(); })
    .then(function(d){
      var s = d && d.score;
      el.style.display='flex';
      if(!s || !s.count){
        el.innerHTML = '⭐ Your store · <span style="color:var(--sub);font-weight:600">No customer reviews yet — they show here as they come in</span>';
        return;
      }
      var nps = (s.nps > 0 ? '+' : '') + s.nps;
      el.innerHTML = '⭐ Your store: <b style="margin:0 4px">' + s.avg + '/10</b> · NPS ' + nps +
        ' · ' + s.count + ' review' + (s.count === 1 ? '' : 's');
    })
    .catch(function(){
      el.style.display='flex';
      el.innerHTML = '<span style="color:var(--tiny);font-weight:600">⭐ Your store score is unavailable right now</span>';
      _storeScoreFetchedFor = null;   // allow a retry on the next store render
    });
}

// v124.3 — the Customer (Reviews) tab. Shows the store's own customer reviews, GOOD
// AND BAD, on the server-enforced 1-hour delay so staff can't trace a fresh review to
// a customer still in store. No contact details / IP — just the rating, comment + date.
function customerReviewWhen(iso){
  if(!iso) return '';
  try { var d = new Date(iso); if(isNaN(d.getTime())) return ''; return d.toLocaleDateString('en-GB', { day:'numeric', month:'short' }); }
  catch(e){ return ''; }
}
function renderCustomerScreen(){
  var el = document.getElementById('customer-screen-body'); if(!el) return;
  if(!currentStore){ el.innerHTML = '<div style="padding:24px 4px;color:var(--sub);font-size:14px">No store is set for this account.</div>'; return; }
  el.innerHTML = '<div style="padding:24px 4px;color:var(--sub);font-size:14px">Loading…</div>';
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  var enc = encodeURIComponent(currentStore);
  Promise.all([
    fetch(base + '/api/customer-score?store=' + enc, { cache: 'no-store' }).then(function(r){ return r.json(); }).catch(function(){ return null; }),
    fetch(base + '/api/customer-reviews?store=' + enc, { cache: 'no-store' }).then(function(r){ return r.json(); }).catch(function(){ return null; })
  ]).then(function(arr){
    var score = arr[0] && arr[0].score;
    var reviews = (arr[1] && arr[1].reviews) || [];
    var head;
    if(score && score.count){
      var nps = (score.nps > 0 ? '+' : '') + score.nps;
      head = '<div style="background:var(--rota-ok-soft);border:1px solid var(--rota-ok-line);border-radius:14px;padding:14px 16px;margin-bottom:14px;text-align:center;color:var(--ok-deep);font-weight:700">' +
        '⭐ <b>' + score.avg + '/10</b> · NPS ' + nps + ' · ' + score.count + ' review' + (score.count===1?'':'s') + '</div>';
    } else {
      head = '<div style="background:var(--rota-ok-soft);border:1px solid var(--rota-ok-line);border-radius:14px;padding:14px 16px;margin-bottom:14px;text-align:center;color:var(--ok-deep);font-weight:700">⭐ No customer reviews yet</div>';
    }
    var list;
    if(!reviews.length){
      list = '<div style="padding:18px 4px;color:var(--sub);font-size:14px">No customer reviews to show yet. New ones appear here about an hour after they are left.</div>';
    } else {
      list = reviews.map(function(rv){
        var rt = Number(rv.rating) || 0;
        var col = rt >= 9 ? 'var(--ok-deep)' : (rt >= 7 ? 'var(--warn-deep)' : 'var(--danger-deep)');
        var bg  = rt >= 9 ? 'var(--rota-ok-soft)' : (rt >= 7 ? 'var(--rota-warn-soft)' : 'var(--rota-danger-soft)');
        return '<div style="background:var(--card);border:1px solid var(--border);border-radius:12px;padding:12px 14px;margin-bottom:10px">' +
          '<div style="display:flex;justify-content:space-between;align-items:center;' + (rv.comment?'margin-bottom:6px':'') + '">' +
            '<span style="font-weight:800;color:' + col + ';background:' + bg + ';border-radius:8px;padding:3px 9px;font-size:13px">' + rt + '/10</span>' +
            '<span style="font-size:12px;color:var(--sub)">' + customerReviewWhen(rv.submitted_at) + '</span>' +
          '</div>' +
          (rv.comment ? '<div style="font-size:14px;color:var(--text);line-height:1.45" translate="no">' + escapeHtml(rv.comment) + '</div>' : '') +
        '</div>';
      }).join('');
    }
    el.innerHTML = head + list;
  });
}

// Recent POSITIVE customer shout-outs for this store (rating >= 8) — a shop-floor
// morale boost. Reads the public /api/customer-shoutouts (positive comments only,
// own store, 1-hour delayed; no contact details). Hidden until there's data.
var _shoutoutsFetchedFor = null;
function renderShoutouts(){
  var el = document.getElementById('storeShoutoutsBar'); if(!el) return;
  if(!currentStore){ el.style.display='none'; return; }
  if(_shoutoutsFetchedFor === currentStore) return;   // already shown for this store
  _shoutoutsFetchedFor = currentStore;
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  fetch(base + '/api/customer-shoutouts?store=' + encodeURIComponent(currentStore), { cache: 'no-store' })
    .then(function(r){ return r.json(); })
    .then(function(d){
      var list = (d && d.shoutouts) || [];
      if(!list.length){ el.style.display='none'; return; }
      el.style.display='block';
      var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); };
      el.innerHTML = '<div style="font-size:11px;font-weight:800;color:var(--ok);text-transform:uppercase;letter-spacing:.5px;margin-bottom:5px">💚 Recent customer shout-outs</div>' +
        list.slice(0,3).map(function(s){
          var c = String(s.comment || '');
          if(c.length > 160) c = c.slice(0,158) + '…';
          return '<div style="font-size:12.5px;color:var(--ok-deep);line-height:1.4;margin-bottom:4px"><span translate="no">\u201C' + esc(c) + '\u201D</span> <b style="white-space:nowrap">' + (Number(s.rating)||0) + '/10</b></div>';
        }).join('');
    })
    .catch(function(){ el.style.display='none'; _shoutoutsFetchedFor = null; });
}

// ── re-expose (preserves the pre-extraction global surface) ──
window.changeAreaViewWeek = changeAreaViewWeek;
window.switchAreaTab = switchAreaTab;
window.renderAreaScreen = renderAreaScreen;
window.renderAreaTabContent = renderAreaTabContent;
window.renderAreaRotaTab = renderAreaRotaTab;
window.renderAreaClockTab = renderAreaClockTab;
window.onKpiStoreChange = onKpiStoreChange;
window.loadKpiData = loadKpiData;
window.kpiFetchRange = kpiFetchRange;   // v130.48 — one definition, both bundles
window.loadAggregateKpi = loadAggregateKpi;
window.aggregateScopeToRange = aggregateScopeToRange;
window.generateKpiAiSummary = generateKpiAiSummary;
window.cancelDemoLineEdit = cancelDemoLineEdit;
window.saveDemoLine = saveDemoLine;
window.cancelKpiNote = cancelKpiNote;
window.saveKpiNote = saveKpiNote;
window.deleteKpiNote = deleteKpiNote;
window.isoWeekFromDateStr = isoWeekFromDateStr;
window.monthLabelFromDateStr = monthLabelFromDateStr;
window.aggregateRows = aggregateRows;
window.isoWeekMonday = isoWeekMonday;
window.compareScopeRange = compareScopeRange;
window.monthLabel = monthLabel;
window.buildMonthOptions = buildMonthOptions;
window.setCompareScope = setCompareScope;
window.setCompareSort = setCompareSort;
window.renderStoreScore = renderStoreScore;
window.renderCustomerScreen = renderCustomerScreen;
window.renderShoutouts = renderShoutouts;

})();
